var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.497 17.516a1.568 1.568 0 0 1-.444-1.17 1.7 1.7 0 0 1 .483-1.171l4.353-4.56H1.707c-.436 0-.802-.156-1.098-.466C.313 9.84.165 9.456.167 9c0-.457.147-.841.443-1.151a1.45 1.45 0 0 1 1.097-.463H18.89l-4.392-4.601a1.61 1.61 0 0 1-.462-1.151c0-.445.154-.828.462-1.15A1.468 1.468 0 0 1 15.596 0c.424 0 .79.161 1.097.484l7.05 7.386c.154.161.263.336.328.525.065.188.096.39.095.605 0 .215-.032.417-.097.605a1.442 1.442 0 0 1-.326.525l-7.089 7.426a1.403 1.403 0 0 1-1.058.444c-.423 0-.79-.161-1.099-.484z",
    fill: "#253331"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forward-arrow.38ebed4bb9793b6ac13fb3ee0b688d58.svg";
export { ForwardRef as ReactComponent };